export default "__VITE_ASSET__05ecd7e1__"